import React, { useState } from 'react';
import './InteractionCapture.css';

const InteractionCapture = ({ onUpdate }) => {
  const [rejectionReason, setRejectionReason] = useState('');
  const [newCapacity, setNewCapacity] = useState('');

  const handleUpdate = () => {
    onUpdate({ rejectionReason, newCapacity });
  };

  return (
    <div className="interaction-capture">
      <h3>Call Interaction Capture</h3>
      <div className="capture-group">
        <label>Carrier Rejection Reason:</label>
        <input
          type="text"
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
          placeholder="e.g., Cannot haul pork"
        />
      </div>
      <div className="capture-group">
        <label>New Carrier Capacity:</label>
        <input
          type="text"
          value={newCapacity}
          onChange={(e) => setNewCapacity(e.target.value)}
          placeholder="e.g., Can't pick up until 2 p.m."
        />
      </div>
      <button onClick={handleUpdate} className="update-btn">Update Recommendations</button>
    </div>
  );
};

export default InteractionCapture;